import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class BringozPodsComponent implements IController {

  pods: any;
  maxPods: any;

  private viewPods: any;
  private extraPodsCount: any;
  private extraPods: any;

  constructor() {
  }

  $onInit() {
    this.viewPods = [];
    this.initPods(this.pods);
  }

  $onChanges(changes) {
    if (changes.tags && !changes.tags.isFirstChange()) {
      this.initPods(this.pods);
    }
  };

  private initPods(pods) {
    this.extraPodsCount = undefined;

    if (_.get(pods, 'length')) {
      this.viewPods = this.maxPods ? _.filter(pods, (item, index) => {
        return index + 1 <= this.maxPods;
      }) : pods;

      if (pods.length > this.viewPods.length) {
        this.extraPodsCount = '+' + (pods.length - this.viewPods.length).toString();
      }

      if (this.extraPodsCount) {
        const podsCopy = angular.copy(this.pods);
        this.extraPods = podsCopy.slice(this.viewPods.length);
      }

    }
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozPods', {
    bindings: {
      pods: '<',
      maxPods: '<?'
    },
    template: require('./bringoz-pods.html').default,
    controller: BringozPodsComponent
  });

